module.exports = "/matchcenter-staging/assets/images/ote_sport_4.808466a5a885d934bf14df9b1d2f4a3d.png";